import { createFileRoute } from "@tanstack/react-router";
import { AdminAudit } from "@/pages/Admin/AdminAudit";

export const Route = createFileRoute("/admin/audit")({
  component: AdminAudit,
});
